// extracted by mini-css-extract-plugin
module.exports = {"container":"handpicked_notice-module_container_1d0e7","avatar":"handpicked_notice-module_avatar_e9f5b"};